import { CountCellProps } from '../../types';
import { formatNumberWithComma } from 'utils';

const TotalOnAgentCountsCell = ({ _customRowProps, data: { countOnAgent } }: CountCellProps) => {
  return <div>{countOnAgent ? formatNumberWithComma(+countOnAgent) : ''}</div>;
};

export default TotalOnAgentCountsCell;
